import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
} from "@mui/material";
import axios from "axios";

const MyShopsPage = () => {
  const [shops, setShops] = useState([]);

  useEffect(() => {
    const rmId = localStorage.getItem("rmId");
    if (rmId) {
      axios
        .get(`https://sakhisshop.com/api/shops/byRm/${rmId}`)
        .then((res) => setShops(res.data || []))
        .catch((err) => {
          console.error("Error fetching shops:", err);
          setShops([]);
        });
    }
  }, []);

  return (
    <Box sx={{ p: { xs: 2, sm: 4 }, fontFamily: "Poppins" }}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ fontWeight: 700, color: "#1b5e20", textAlign: "center", mb: 4 }}
      >
        My Shops
      </Typography>

      <TableContainer component={Paper} sx={{ boxShadow: 4, borderRadius: 3 }}>
        <Table sx={{ minWidth: 300 }}>
          <TableHead sx={{ bgcolor: "#c8e6c9" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Shop ID</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Shop Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Address</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Owner</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shops.map((shop) => (
              <TableRow
                key={shop.sID}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f1f8e9",
                    transform: "scale(1.01)",
                    transition: "0.2s",
                  },
                }}
              >
                <TableCell>{shop.sID}</TableCell>
                <TableCell>{shop.shopname}</TableCell>
                <TableCell>{shop.address}</TableCell>
                <TableCell>{shop.owner || "N/A"}</TableCell>
              </TableRow>
            ))}
            {shops.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                  No shops found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default MyShopsPage;
